import axios from "axios-jsonp-pro";
import { settings } from "./settings";

const URL =
  "https://storage.googleapis.com/dlg-ecom-storage-hmc.delonghigroup.com/data/";
const ext = ".js";

export const getJsonData = async (key) => {
  try {
    const response = await axios.jsonp(URL + key + ext);
    settings.form = response;
    return response;
  } catch (error) {
    console.error(error);
  }
};
